// Simple tooltip logic for dropdown-localization__button
// Appends a tooltip div on hover/focus, removes on leave/blur

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.dropdown-localization__button').forEach(function (btn) {
    /** @type {HTMLDivElement|null} */
    let tooltip = null;
    /** @type {MutationObserver|null} */
    let observer = null;
    const getTooltipText = () => {
      const country = btn.getAttribute('data-country-name') || '';
      const currency = btn.getAttribute('data-currency-code') || '';
      const symbol = btn.getAttribute('data-currency-symbol') || '';
      if (symbol && symbol !== currency) {
        return `Country: ${country}\nCurrency: ${symbol} ${currency}`;
      }
      return `Country: ${country}\nCurrency: ${currency}`;
    };
  /** @type {(() => void)|null} */
  let updatePosition = null;

  function showTooltip() {
      // Don't show the tooltip when the dropdown is open
      if (btn.getAttribute('aria-expanded') === 'true') return;
      if (tooltip) return;
      tooltip = document.createElement('div');
      tooltip.className = 'dropdown-localization-tooltip';
      tooltip.textContent = getTooltipText();
  // Append to body so it can't interfere with local event handlers or layout
  // and position fixed so it stays aligned to sticky headers.
  document.body.appendChild(tooltip);
  // Accessibility: mark as presentational/non-interactive
  tooltip.setAttribute('role', 'tooltip');
  tooltip.setAttribute('aria-hidden', 'true');
  // Make tooltip transparent to pointer events so it doesn't block clicks
  tooltip.style.pointerEvents = 'none';
  // Position bottom-end relative to the viewport (fixed)
  const rect = btn.getBoundingClientRect();
  tooltip.style.position = 'fixed';
      // Use a requestAnimationFrame loop to wait for layout to settle and width to stabilize
      let rafId = null;
      let lastWidth = -1;
      const rafLoop = () => {
        if (!tooltip) return;
        const width = tooltip.offsetWidth;
        tooltip.style.left = (rect.right - width) + 'px';
        tooltip.style.top = (rect.bottom + 8) + 'px';
        // Stop when width is stable and non-zero
        if (width > 0 && width === lastWidth) {
          rafId = null;
          return;
        }
        lastWidth = width;
        rafId = requestAnimationFrame(rafLoop);
      };
      rafId = requestAnimationFrame(rafLoop);
  tooltip.style.zIndex = '1000';

      // Update position on scroll/resize while visible
      updatePosition = () => {
        if (!tooltip) return;
        const r = btn.getBoundingClientRect();
        tooltip.style.left = (r.right - tooltip.offsetWidth) + 'px';
        tooltip.style.top = (r.bottom + 8) + 'px';
      };
      window.addEventListener('scroll', updatePosition, { passive: true });
      window.addEventListener('resize', updatePosition);

      // Observe aria-expanded changes so we can hide tooltip when the popover opens
      if (!observer) {
        observer = new MutationObserver(function (mutations) {
          for (const m of mutations) {
            if (m.type === 'attributes' && m.attributeName === 'aria-expanded') {
              if (btn.getAttribute('aria-expanded') === 'true') {
                hideTooltip();
              }
            }
          }
        });
        observer.observe(btn, { attributes: true, attributeFilter: ['aria-expanded'] });
      }
    }
    function hideTooltip() {
      if (tooltip) {
        tooltip.remove();
        tooltip = null;
      }
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      // Remove listeners added while visible
      if (updatePosition) {
        window.removeEventListener('scroll', updatePosition);
        window.removeEventListener('resize', updatePosition);
        updatePosition = null;
      }
    }
    btn.addEventListener('mouseenter', showTooltip);
    btn.addEventListener('focus', showTooltip);
    btn.addEventListener('mouseleave', hideTooltip);
    btn.addEventListener('blur', hideTooltip);
  });
});
